export enum ERoutes {
  Home = "/",
  Brands = "/brands/",
  Overview = "/overview/",
  Source = "/source/",
  SourceDetail = "/source/:id/",

  PromptsHome = "/prompts/",
  Prompts = "/prompts/:id/",
  PromptsDayly = "/prompts/:id/daily/:date/",

  ModelsHome = "/models/",
  Models = "/models/:id/",
  ModelsDayly = "/models/:id/daily/:date/",

  Settings = "/settings/",
  SettingsPrompts = "/settings/prompts/",
  SettingsModels = "/settings/models/",
  SettingsCompetitors = "/settings/competitors/",
  SettingsApiKeys = "/settings/api-keys/",
  SettingsAddMember = "/settings/add-member/",

  Auth = "/auth/",
  Login = "/auth/signin/",
  Register = "/auth/signup/",
  OAuthLogin = "/auth/oauth/login/",
  OAuthRegister = "/auth/oauth/register/",
  ForgotPassword = "/auth/forgot-password/",
  ResetPassword = "/auth/reset-password/",
  AuthBrands = "/auth/brands/",

  Payment = "/payment/",
  PaymentSuccess = "/payment/success/",
  Logout = "/logout/",
  Superuser = "/superuser/",

  InvitationAccept = "/invitations/accept/:token",

  Agency = "/agency/",

  AddNewBrand = "/add-new-brand/",
  AddNewBrandCompetitors = "/add-new-brand/competitors/",
}

export const DEFAULT_AUTHENTICATED_ROUTE = ERoutes.Overview;
